import React, { Component } from 'react';
import PropTypes from 'prop-types';

import UI from './ProductBox.ui';

class ProductBox extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  constructor(...args) {
    super(...args);
    this.state = ({});
  }

  render() {
    return (
      <UI
        props={this.props.items}
        onProductClick={this.props.onProductClick}
        name={this.props.name}
        defaultPlanName={this.props.defaultPlanName}
        selected={this.props.selected}
        setListCompare={this.props.setListCompare}
        listCompare={this.props.listCompare}
        categorySlug={this.props.categorySlug}
        categoryName={this.props.categoryName}
        categoryId={this.props.categoryId}
        resetCatalog={this.props.resetCatalog}
        setShowModalComparator={this.props.setShowModalComparator}
        categorySlugSearch={this.props.categorySlugSearch}
        showESimIndicator={this.props?.showESimIndicator}
        esimIndicator={this.props?.esimIndicator}
      />
    // <UI props={this.props.items} onProductClick={this.props.onProductClick} name={this.props.name} defaultPlanName={this.props.defaultPlanName} selected={this.props.selected}  />
    );
  }
}

ProductBox.propTypes = {
  items: PropTypes.shape({}),
};

ProductBox.defaultProps = {
  items: {},
  showESimIndicator: false,
  esimIndicator: null
};

export default ProductBox;
